import { useEffect, useState } from "react";
import { GTBRecordsHistory } from "../../helpers/interfaces";
import React from "react";

import { Button, Grid, MenuItem, Pagination, Stack, Table, TableBody, TableHead } from "@mui/material";
import { CustomTextField, StyledTableCell, StyledTableRow } from "../../layouts/themes";
import { formatShortDateString, getNameFromTotalEnergiesEmail } from "../../helpers/utils";
import { ArrowBack, Refresh, RemoveRedEye } from "@mui/icons-material";
import SAPGTBRecords from "./SAPGTBRecords";
import { fetchGTBRecordsHistory, getSAPGTBRecords } from "../../apiServices/GTBRecordsApi";

interface Props {
    generalBlanceRecordsHistory: GTBRecordsHistory[]

}

function GeneralTrialBalanceHistory(props: Props) {
    const [filteredGeneralTrialBlanceRecordsHistory, setFilteredGeneralTrialBlanceRecordsHistory] = useState<GTBRecordsHistory[]>([])
    const [searchQuery, setSearchQuery] = useState<string>("");
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [recordsPerPage, setRecordsPerPage] = useState<number>(5);
    const [numOfPages, setNumOfPages] = useState<number>(0);
    const [currentPageRecords, setCurrentPageRecords] = useState<GTBRecordsHistory[]>([])

    const [year, setYear] = useState<number>(2025);
    const [viewGTBRecords, setViewGTBRecords] = React.useState(false);

    const [gtbRecordsToView, setGTBRecordsToView] = useState<string>("");

    function handleSAPGTBRecords() {
        getSAPGTBRecords(year).then(() => {
           fetchGTBRecordsHistory().then(GTBRecordsHistory => setFilteredGeneralTrialBlanceRecordsHistory(GTBRecordsHistory))
            
        })
    }
    useEffect(() => {
        setFilteredGeneralTrialBlanceRecordsHistory(props.generalBlanceRecordsHistory.filter(e =>
            (searchQuery === "" || e.fetchedBy.toLowerCase().includes(searchQuery.toLowerCase()) || e.id.toLowerCase().includes(searchQuery.toLowerCase()))
        ));
        setCurrentPage(1);
    }, [searchQuery, props.generalBlanceRecordsHistory])


    useEffect(() => {
        setNumOfPages(Math.ceil(filteredGeneralTrialBlanceRecordsHistory.length / recordsPerPage))
    }, [recordsPerPage, filteredGeneralTrialBlanceRecordsHistory])

    useEffect(() => {
        const lastIndex = currentPage * recordsPerPage;
        const firstIndex = lastIndex - recordsPerPage;
        setCurrentPageRecords(filteredGeneralTrialBlanceRecordsHistory.slice(firstIndex, lastIndex))
    }, [currentPage, recordsPerPage, filteredGeneralTrialBlanceRecordsHistory])

    const handleEdit = (record: GTBRecordsHistory) => {
        setGTBRecordsToView(record.id)
        setViewGTBRecords(true);
    }
    const handleBack = () => {
        setGTBRecordsToView('')
        setViewGTBRecords(false);
    }
    return (
        <>
            <div className=" flex flex-row ">
                <div className=' flex w-2/3 '>
                    {viewGTBRecords &&
                        <><Button variant="contained" size="small" color="secondary" onClick={handleBack}><ArrowBack /> &nbsp; Back</Button></>
                    }
                    {!viewGTBRecords &&
                        <><CustomTextField size="small" id="outlined-basic" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} variant="outlined" sx={{ width: '50%' }} /> &nbsp;</>
                    }
                </div>
                <div style={{ flexGrow: 1 }} />
                {viewGTBRecords &&
                    <>
                        <CustomTextField size="small" id="outlined-basic" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} variant="outlined" sx={{ width: '50%' }} /> &nbsp;
                    </>
                }
                {!viewGTBRecords &&
                    <>
                        <CustomTextField
                            size="small"
                            placeholder="Enter Year..."
                            value={year}
                            onChange={(e) => setYear(Number(e.target.value))}
                            variant="outlined"
                            sx={{ width: "20%" }}
                        />
                        &nbsp;
                        <Button color='secondary' variant="contained" style={{ textTransform: 'none', fontSize: 13, }} onClick={handleSAPGTBRecords}> <Refresh /> Fetch GTB Data</Button>
                    </>

                }
            </div>
            <br />
            <>
                {!viewGTBRecords &&
                    <>
                        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                            <Table>
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell> SN</StyledTableCell>
                                        <StyledTableCell>Year</StyledTableCell>
                                        <StyledTableCell>Fetched By </StyledTableCell>
                                        <StyledTableCell>Fetched At</StyledTableCell>
                                        <StyledTableCell>Actions</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {currentPageRecords.map((item, index) => {
                                        return <StyledTableRow key={index}>
                                            <StyledTableCell  >
                                                {index + 1 + ((currentPage - 1) * recordsPerPage)}
                                            </StyledTableCell>
                                            <StyledTableCell>{item.year}</StyledTableCell>
                                            <StyledTableCell  >{getNameFromTotalEnergiesEmail(item.fetchedBy)}</StyledTableCell>
                                            <StyledTableCell  >{formatShortDateString(item.fetchedAt, true)}</StyledTableCell>


                                            <StyledTableCell  >
                                                <Button variant="contained" color="info" onClick={() => { handleEdit(item) }}><RemoveRedEye /> &nbsp;View</Button>

                                            </StyledTableCell>

                                        </StyledTableRow>
                                    })}

                                    {currentPageRecords.length === 0 &&
                                        <tr>
                                            <StyledTableCell colSpan={5}><p style={{ fontSize: '11px', textAlign: 'center' }}>No record available...</p></StyledTableCell>
                                        </tr>
                                    }
                                </TableBody>
                            </Table>
                        </div>
                        <br />

                        <nav>
                            <div className=" flex flex-row ">
                                <div className=" flex items-start ">
                                    <div className="px-6 py-2">Rows per page</div>&nbsp;
                                    < Grid item xs={12} lg={3} >
                                        <CustomTextField fullWidth id="fullWidth" select variant="outlined" size="small" name="RequestsNumbers" value={recordsPerPage} onChange={(e) => setRecordsPerPage(Number(e.target.value))} >
                                            <MenuItem value="5">5</MenuItem >
                                            <MenuItem value="15">15</MenuItem >
                                            <MenuItem value="25">25</MenuItem >
                                            <MenuItem value="40">40</MenuItem >
                                            <MenuItem value="55">55</MenuItem >
                                            <MenuItem value="85">85</MenuItem >
                                            <MenuItem value="125">125</MenuItem >
                                            <MenuItem value="200">200</MenuItem >
                                            <MenuItem value="255">255</MenuItem >
                                            <MenuItem value="350">350</MenuItem >
                                            <MenuItem value="500">500</MenuItem >


                                        </CustomTextField>
                                    </Grid>
                                </div>
                                <div style={{ flexGrow: 1 }} />
                                <Stack spacing={2}>
                                    <Pagination color="secondary" count={numOfPages} siblingCount={1} boundaryCount={1}
                                        onChange={(event, value) => setCurrentPage(value)} page={currentPage} size="small" classes={{ ul: "PaginationUl" }} />
                                </Stack>

                            </div>
                            <br />


                        </nav>
                    </>

                }
            </>


            {viewGTBRecords &&

                <SAPGTBRecords gtbRecordsToView={gtbRecordsToView} />

            }
        </>
    )
}
export default GeneralTrialBalanceHistory;